<p>
    I was hired by Everyday Arcade to code "The Voter
    Suppression Trail", which was published in The New York Times as "the
    first-ever video game for Op-Docs" in a series about the 2016 election.
</p>
